import request from '@/plugins/request';

/**
 * 获取品牌介绍信息
 * @returns {Promise} - 返回Promise对象
 */
export function getBrandInfo() {
  return request({
    url: '/fronted/brand/list',
    method: 'get'
  });
}

/**
 * 获取品牌历史
 * @returns {Promise} - 返回Promise对象
 */
export function getBrandHistory() {
  return request({
    url: '/fronted/brand/history',
    method: 'get'
  });
}

/**
 * 获取品牌优势/特点
 * @returns {Promise} - 返回Promise对象
 */
export function getBrandAdvantages() {
  return request({
    url: '/fronted/brand/advantages',
    method: 'get'
  });
}

/**
 * 获取品牌荣誉/证书
 * @param {Object} params - 请求参数，如页码等
 * @returns {Promise} - 返回Promise对象
 */
export function getBrandHonors(params) {
  return request({
    url: '/fronted/brand/honors',
    method: 'get',
    params
  });
} 